
var now = timer.split(":");
var hours = now[0];
var minutes = now[1];
var seconds = now[2];

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype.isDstObserved = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
}

var today = new Date();
if (!today.isDstObserved()) {
  hours++;
}

var $time = $(".time-now");
if ($time.length > 0) {
  // Update the count down every 1 second
  var x = setInterval(function() {
    // Get todays date and time
    seconds++;
    //console.log('Seconds :: ', seconds);

    if(seconds === 60) {
      seconds = 0;
      minutes++;
    }
    if(minutes === 60) {
      minutes = 0;
      hours++;
    }
    if(hours === 24)
      hours = 0;

    // Display Time
    $time.text(
      formatTimeString(parseInt(hours)) + ":" +
      formatTimeString(parseInt(minutes)) + ":" +
      formatTimeString(parseInt(seconds))
    );
  }, 1000);
}

function formatTimeString(n) {
	return n < 10 ? '0' + n : n;
}

